import { Link, useSearchParams } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'

export default function OrderSuccess() {
  const [params] = useSearchParams()
  const name = params.get('name') || ''
  const ref = params.get('ref') || ''
  const business = params.get('business') || ''
  const branch = params.get('branch') || ''
  const date = params.get('date') || ''
  const total = params.get('total') || ''
  const payment = params.get('payment') || ''

  const shortRef = ref ? ref.slice(0, 8).toUpperCase() : ''

  return (
    <div>
      <section className="bg-charcoal relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-20">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-6 h-0.5 bg-terracotta" />
            <span className="font-body text-[11px] font-semibold tracking-[0.25em] uppercase text-terracotta">Confirmed</span>
          </div>
          <h1 className="font-display text-cream tracking-[0.04em] leading-[0.95]" style={{ fontSize: 'clamp(36px, 5vw, 72px)' }}>
            Order Placed
          </h1>
        </div>
      </section>
      <div className="h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />
      <section className="bg-umber">
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-20 text-center">
          <CheckCircle size={56} className="text-terracotta mx-auto mb-6" />
          <h2 className="font-display text-cream text-3xl tracking-wide mb-4">
            Thank you{name ? `, ${name}` : ''}!
          </h2>
          {shortRef && (
            <div className="inline-block bg-surface-high border border-border-dark px-6 py-3 mb-4">
              <span className="text-[11px] text-muted block font-body tracking-[0.15em] uppercase">Order Reference</span>
              <span className="font-display text-2xl text-cream tracking-wider">#{shortRef}</span>
            </div>
          )}
          <p className="text-sm text-ink-mid mb-2 leading-relaxed">
            Your order has been submitted{business ? <> to <strong>{business}</strong></> : ''}.
          </p>
          <p className="text-sm text-ink-mid mb-2 leading-relaxed">
            You'll receive a WhatsApp confirmation shortly. We'll message you again when your order is ready for collection
            {date && <> on <strong>{date}</strong></>}
            {branch && <> at our <strong>{branch}</strong> branch</>}.
          </p>
          {payment && <p className="text-sm font-body font-semibold text-terracotta mb-2">Payment: {payment}</p>}
          {total && <p className="text-sm text-muted mb-4">Total: R{total}</p>}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <Link to="/menu" className="inline-flex items-center justify-center gap-2 bg-terracotta text-white font-body text-[13px] font-bold tracking-[0.1em] uppercase px-9 py-4 hover:bg-terracotta-glow hover:-translate-y-0.5 transition-all">
              Back to Menu
            </Link>
            <Link to="/" className="inline-flex items-center justify-center gap-2 bg-transparent text-cream border border-border-dark font-body text-[13px] font-bold tracking-[0.1em] uppercase px-9 py-4 hover:border-terracotta hover:text-terracotta transition-all">
              Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
